<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <SubpageHeader
        :is_sticky="true"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="dummyLog()"
      />
      <div class="work-package-loglist-detail-container">
        <TextArea
          :text="log.value"
          label="Loglist Entry"
          autofocus_id="loglist-entry-id"
          placeholder="Entry text..."
          :max_char_count="255"
          :height="350"
          :background_color="bg"
          :foreground_color="fg"
          @change="dummyLog()"
        />
        <div style="width: 100%; display: flex; justify-content: flex-end; grid-gap: 8px;">
          <ButtonOutlined
            icon="bin"
            text="Cancel"
            :color="fg"
            @buttonClicked="dummyLog()"
          />
          <ButtonOutlined
            icon="floppy-disc"
            text="Save"
            :color="fg"
            @buttonClicked="dummyLog()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

  export default {
    components: {
      SubpageHeader,
      TextArea,
      ButtonOutlined,
    },

    mixins: [
      WorkPackageWIPMixin,
    ],

    data: () => ({
      log:{
        target: 'Work Package',
        action: 'comment',
        user: 'Marco Herold',
        date: '2021-09-29 13:43:23 UTC',
        value: 'comment with some useful information',
        is_strikethrough: false,
      },

      is_edit: true,
      is_new: false,

      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',
    }),

    methods: {
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  .work-package-loglist-detail-container {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
  }
  .work-package-loglist-detail-head {
    display: flex;
    justify-content: space-between;
  }
  .work-package-loglist-detail-head-spacer {
    margin-top: 10px;
  }
  .work-package-loglist-detail-head-right-side {
    display: flex;
    grid-gap: 4px;
  }
  .work-package-loglist-detail-save-button {
    width: 100px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 4px;
    border: 1px solid;
    border-radius: 4px;
  }
</style>
